import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { API_REQUEST_URL, EXPORT_BOS_API_REQUEST_URL } from '../../../../common/apiConfig';
import {
  MANAGE_OUTS_FETCH_ORDERS_BEGIN,
  MANAGE_OUTS_FETCH_ORDERS_SUCCESS,
  MANAGE_OUTS_FETCH_ORDERS_FAILURE,
  MANAGE_OUTS_FETCH_ORDERS_DISMISS_ERROR,
  MANAGE_OUTS_ERROR_CONTACT_ADMIN,
} from './constants';

export function fetchManageOutsOrders(formData = {}) {
  return (dispatch, getState) => {
    dispatch({ type: MANAGE_OUTS_FETCH_ORDERS_BEGIN });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home && getState().home.auth && getState().home.auth.cognitoIdToken;
      if (!cognitoIdToken) {
        const errMsg = 'Missing auth token';
        dispatch({ type: MANAGE_OUTS_FETCH_ORDERS_FAILURE, data: { error: errMsg } });
        return reject(new Error(errMsg));
      }
      const token = `Bearer ${cognitoIdToken}`;

      const pageIndex = parseInt(formData.pageIndex, 10) || 1;
      const pageSize = parseInt(formData.pageSize, 10) || 5;

      // Build payload: drop undefined/empty values, keep strings for IDs/dates
      const payload = Object.keys(formData).reduce((acc, k) => {
        const v = formData[k];
        if (v === undefined || v === '') return acc;
        acc[k] = v;
        return acc;
      }, {});
      payload.pageIndex = pageIndex;
      payload.pageSize = pageSize;
      if (payload.orderNumber && /^\d+$/.test(String(payload.orderNumber))) {
        payload.orderNumber = String(payload.orderNumber);
      }
      // const endpointBase = EXPORT_BOS_API_REQUEST_URL || API_REQUEST_URL;
      // const url = `${endpointBase.replace(/\/$/, '')}/manageOutsHistorySearch`;

      const url = `${API_REQUEST_URL}/manageOutsHistorySearch`;
      const doRequest = axios.post(
        url,
        payload,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
            'Accept-Language': 'en',
          },
        },
      );
      doRequest.then(
        (res) => {
          const rows = res.data && (res.data.data || res.data.rows) ? (res.data.data || res.data.rows) : [];
          const total = res.data && (res.data.total || res.data.totalCount) ? (res.data.total || res.data.totalCount) : (Array.isArray(rows) ? rows.length : 0);
          const result = { rows, total, pageIndex, pageSize };
          dispatch({ type: MANAGE_OUTS_FETCH_ORDERS_SUCCESS, data: result });
          resolve(result);
        },
        (err) => {
          //const errorMsg = err && err.response && (err.response.data && err.response.data.message) ? err.response.data.message : MANAGE_OUTS_ERROR_CONTACT_ADMIN;
          const errorMsg = `No Orders Found`;
          dispatch({ type: MANAGE_OUTS_FETCH_ORDERS_FAILURE, data: { error: errorMsg } });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchManageOutsOrdersError() {
  return { type: MANAGE_OUTS_FETCH_ORDERS_DISMISS_ERROR };
}

export function useFetchManageOutsOrders() {
  const dispatch = useDispatch();
  const { ordersData, ordersTotal, fetchOrdersPending, fetchOrdersError } = useSelector(
    state => ({
      ordersData: state.manageOutsAuditTrail.ordersData,
      ordersTotal: state.manageOutsAuditTrail.ordersTotal,
      fetchOrdersPending: state.manageOutsAuditTrail.fetchOrdersPending,
      fetchOrdersError: state.manageOutsAuditTrail.fetchOrdersError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => dispatch(fetchManageOutsOrders(...args)), [dispatch]);
  const boundDismiss = useCallback(() => dispatch(dismissFetchManageOutsOrdersError()), [dispatch]);

  return {
    ordersData,
    ordersTotal,
    fetchManageOutsOrders: boundAction,
    fetchOrdersPending,
    fetchOrdersError,
    dismissFetchManageOutsOrdersError: boundDismiss,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_OUTS_FETCH_ORDERS_BEGIN:
      return {
        ...state,
        fetchOrdersPending: true,
        fetchOrdersError: null,
      };

    case MANAGE_OUTS_FETCH_ORDERS_SUCCESS:
      return {
        ...state,
        ordersData: action.data.rows || [],
        ordersTotal: action.data.total || 0,
        fetchOrdersPending: false,
        fetchOrdersError: null,
      };

    case MANAGE_OUTS_FETCH_ORDERS_FAILURE:
      return {
        ...state,
        fetchOrdersPending: false,
        fetchOrdersError: action.data.error,
      };

    case MANAGE_OUTS_FETCH_ORDERS_DISMISS_ERROR:
      return {
        ...state,
        fetchOrdersError: null,
      };

    default:
      return state;
  }
}

